import PropTypes from "prop-types";
import { useQuery } from "@tanstack/react-query";
import ThreatStatusLabel from "../../../../../components/ThreatStatusLabel";
import api from "../../../../../services/api/index";
import { enums } from "../../../../../shim/jsbridge";
import shortNumberFormat from "../../../../../tcbase/utils/short_number_format";
import { FILTER_KEYWORDS } from "../../../../search/consts";
import { sampleReportKeys } from "../../../queryKeys";
import { getSearchPivotLink } from "../../../util";

const SampleReportGridUriStats = ({ url, customStyle }) => {
  const { data: uriStats, isPending: isLoading } = useQuery({
    queryKey: sampleReportKeys.uriStatsByUrl(url),
    queryFn: () =>
      api
        .uriStats({ requestData: [url] })
        .then(resp => resp.data[url]?.counters ?? null)
  });
  const threatCountClassificationOrder = Object.keys(enums.threat_status)
    .reverse()
    .slice(0, -1);
  return (
    <div
      className={`sample-report-grid__threat-counts ${
        !uriStats && `sample-report-grid__threat-counts--no-counts`
      }`}
      style={customStyle}
    >
      {isLoading ? (
        <div>Loading...</div>
      ) : (
        threatCountClassificationOrder.map(classification => (
          <span
            className="sample-report-grid__threat-count-item"
            key={classification}
          >
            <ThreatStatusLabel
              threatStatus={classification}
              showColor
              labelText={
                uriStats
                  ? shortNumberFormat(
                      uriStats[classification.toLowerCase()]
                    ).toString()
                  : "0"
              }
              url={
                uriStats &&
                getSearchPivotLink(`${enums.search_types.URI}: "${url}"`, {
                  [FILTER_KEYWORDS.CLASSIFICATION]:
                    classification?.toLowerCase()
                })
              }
              openNewTab
            />
          </span>
        ))
      )}
    </div>
  );
};

SampleReportGridUriStats.propTypes = {
  url: PropTypes.string,
  customStyle: PropTypes.shape()
};

export default SampleReportGridUriStats;
